import { AxiosInstance } from 'axios';
import { ShiftDatesRepository } from '@/model/repository/shift/ShiftDatesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ShiftDatesRepository => ({
    index(payload) {
      const { year, month, day, facilityIds, firstDayOfTheMonth } = payload;
      const facilityIdParam = facilityIds.map((facilityId) => `facilityIds[]=${facilityId}`).join('&');

      if (day) {
        return Repository.get(
          `${resource}/${Number(year)}/${Number(month)}/${Number(
            day
          )}?${facilityIdParam}&firstDayOfTheMonth=${firstDayOfTheMonth}`
        );
      }
      return Repository.get(
        `${resource}/${Number(year)}/${Number(month)}?${facilityIdParam}&firstDayOfTheMonth=${firstDayOfTheMonth}`
      );
    },
  });
